import { useInvitations } from '@/models/userRole';

import { Filters } from './Filters/Filters';
import { FiltersStateContext, useFiltersState } from './Filters/FiltersState';
import { INVITATIONS_PER_PAGE, InvitationsTable } from './InvitationsTable';

export const Invitations = () => {
  const filters = useFiltersState();

  const {
    data: { invitations, meta } = {},
    isLoading,
    isPlaceholderData,
    isError,
  } = useInvitations(
    {
      limit: INVITATIONS_PER_PAGE,
      offset: (filters.page.page - 1) * INVITATIONS_PER_PAGE,
      search: filters.search.debouncedSearch || undefined,
      roleIds: filters.roles.roles.map(({ id }) => id),
      entityIds: filters.entities.entities.map(({ id }) => id),
    },
    { keepPreviousData: true }
  );

  return (
    <main style={{ gap: '1rem' }}>
      <FiltersStateContext value={filters}>
        <Filters />
      </FiltersStateContext>
      <InvitationsTable
        invitations={invitations ?? []}
        isLoading={isLoading || !!isPlaceholderData}
        isError={isError}
        page={filters.page.page}
        onPageChange={filters.page.setPage}
        count={meta?.count}
      />
    </main>
  );
};
